// Libs
import classNames from 'classnames/bind';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './BaseToolbar.module.scss';
import { icons } from '~/assets';

type Props = {
  title?: string;
  secondaryTitle?: string;
  textAction?: string;
  selectedCount?: number;
  children?: ReactNode;
  onAction?: () => void;
  onDelete?: () => void;
};

const cx = classNames.bind(styles);

const BaseToolbar = (props: Props) => {
  //#region Destructuring Props
  const { title, secondaryTitle, textAction, children, onAction, onDelete, selectedCount = 0 } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack
      component={'div'}
      id='baseToolbarComponent'
      direction={'row'}
      alignItems={'center'}
      justifyContent={title || secondaryTitle ? 'space-between' : 'flex-end'}
      gap={'20px'}
      flexWrap={'wrap'}
      className={cx('container')}
    >
      <Stack direction={'row'} alignItems={'center'} gap={'16px'}>
        {title && <Typography className={cx('title')}>{title}</Typography>}
        {secondaryTitle && (
          <Box component={'div'} className={cx('secondaryTitleContainer')}>
            <Typography className={cx('secondaryTitle')}>{secondaryTitle}</Typography>
          </Box>
        )}
      </Stack>

      <Stack
        flexShrink={0}
        direction={'row'}
        alignItems={'center'}
        justifyContent={'flex-end'}
        gap={'10px'}
        className={cx('group')}
      >
        {selectedCount > 0 && (
          <Button
            onClick={onDelete}
            color='error'
            startIcon={
              <img src={icons.tableIconActionDelete} alt={t('alt_img')} className={cx('itemIconImg')} />
            }
          >
            {t('table_action_delete_multiple', { selectedCount: selectedCount })}
          </Button>
        )}
        {children}

        {onAction && (
          <Button variant='contained' onClick={onAction} className={cx('btn')}>
            <Typography className={cx('textBtn')}>{textAction || t('common_text_action')}</Typography>
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default BaseToolbar;
